import * as R from 'ramda';
import axios from 'axios';

import {URLS} from 'js/common';
import * as ObjectHelper from 'js/common/object_helper';

const AddressComponentType = {
    floor: 'floor',
    streetNumber: 'street_number',
    route: 'route',
    neighborhood: 'neighborhood',
    locality: 'locality',
    state: 'administrative_area_level_1',
    country: 'country',
    zip: 'postal_code'
};

const GoogleMapsApi = {
    /**
     * @param {Object} params
     * @return {*}  {Promise<Object>}
     */
    placesQueryAutoComplete(params) {
        return axios.get(URLS.places_autocomplete, {params});
    },
    /**
     * @param {Object} params
     * @return {*}  {Promise<Object>}
     */
    placeDetails(params) {
        return axios.get(URLS.place_details, {params});
    }
};

export function transformPlaceDetailsToUserProfileDetails(place) {
    const {
        floor,
        street_number,
        route,
        city,
        state,
        country,
        zip_code
    } = extractUserProfileComponentsFromPlace(place);

    const floorComponent = floor ? `${floor}, ` : '';

    /**
     * Maps autocomplete suggestions may not have a street number,
     * and we consider it better to have no address than an invalid one.
     */
    const address = street_number ? `${floorComponent}${street_number} ${route}` : '';

    return {
        address,
        city,
        state,
        country,
        zip_code
    };
}

function extractUserProfileComponentsFromPlace(place) {
    /**
     * Search place.components, which will look like:
     * [
     *    { types: ['route'] }
     *    { types: ['locality', 'political'] }
     * ]
     */
    const firstComponentWithType = type =>
        R.find(({types}) => R.contains(type, types), place.address_components);

    const shortName = ObjectHelper.propOr(null, 'short_name');

    const getComponent = R.pipe(firstComponentWithType, shortName);

    return {
        floor: getComponent(AddressComponentType.floor),
        street_number: getComponent(AddressComponentType.streetNumber),
        route: getComponent(AddressComponentType.route),
        /**
         * We prefer locality because these are typically larger areas,
         * for instance, Westwood may be a neighborhood but Los Angeles is a locality
         * and for search purposes, Los Angeles would be better to store.
         * */
        city: getComponent(AddressComponentType.locality),
        state: R.pipe(
            getComponent,
            R.ifElse(R.isNil, R.identity, R.toLower)
        )(AddressComponentType.state),
        country: R.pipe(
            getComponent,
            R.ifElse(R.isNil, R.identity, R.toLower)
        )(AddressComponentType.country),
        zip_code: getComponent(AddressComponentType.zip)
    };
}

export default GoogleMapsApi;



// WEBPACK FOOTER //
// ./google/maps/index.js